export class MemberDto {
    id: number;
    memberId: number;
    firstName: string;
    lastName: string;
    dateOfBirth: Date;
    relationshipType: string;
    gender: string;
    dateAdded: Date;
    middleName: string;
    duplicateKey: string;
    duplicateStatus: string;
    agencyId: number;
    caseId: number;
    currentNeed: string;
    caseNumber: string;
    applicantFirstName: string;
    applicantMiddleName: string;
    applicantLastName: string;
    caseStatus:String;
    dateOpened: Date;
    dateClosed: Date;
    memberComments: string;
  }
